export default "__VITE_ASSET__BDrFwuZK__"